import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';

const NotFoundPage: React.FC = () => (
  <Container maxWidth="sm" sx={{ py: 10 }}>
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h2" fontWeight={700} gutterBottom>
        404
      </Typography>
      <Typography variant="h6" gutterBottom>
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        The page you are looking for does not exist or has moved.
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        Back to jobs
      </Button>
    </Box>
  </Container>
);

export default NotFoundPage;
